import { Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	templateUrl: './adblock-dialog.component.html',
	standalone: false,
})
export class AdblockDialogComponent {
	readonly dialogRef = inject(DynamicDialogRef);
}
